import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from '@/shared/providers/queryClient';
import { RoleProvider } from '@/shared/contexts/RoleContext';
import { ErrorBoundary } from '@/shared/components/feedback/ErrorBoundary';
import { ToastWrapper } from '@/shared/components/feedback/ToastWrapper';

/** Global provider stack: error boundary → query → router → role context. */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <RoleProvider>
            {children}
            <ToastWrapper />
          </RoleProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
